/* import __COLOCATED_TEMPLATE__ from './data.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import Component from '@glimmer/component';
import { action } from '@ember/object';

interface Signature {
  Args: {
    changeTab?: (value: string) => void;
    openSection: string | null;
    setSection?: (section: string | null) => void;
  };
}

export default class SunshineDataTab extends Component<Signature> {
  @action
  continue() {
    this.args.changeTab?.('workflow');
  }

  @action
  setSection(section: string | null) {
    this.args.setSection?.(section);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Zendesk::Deploy::Sunshine::Tabs::Data': typeof SunshineDataTab;
  }
}
